export const NEW_RECORD_ENCID = 'J3SuSf1SKTYL0rDGjV37p4j1Ts_guBX721uT3JULVf9d8dv76yIthhod3Sp3n9McVF2XllD5j013_oPeQ2VJl0EfPXXYg4lj4y-8Aevmb8-xJk6Rs7yz10n-4NABDCl4PEfBAwe'

export const BASE_DATE_FORMAT = 'MM/DD/YYYY'

// ********************************************************
// MENU ITEM ID
// ********************************************************
// System
export const MENUID_USERS = 101101
export const MENUID_ROLES = 101102
export const MENUID_SYSTEM_ANNOUNCEMENTS = 101103
export const MENUID_CURRENCY = 101104
export const MENUID_CURRENCYBASE = 101105

// General Ledger
export const MENUID_ACCCAT = 103101
export const MENUID_ACCCHARTS = 103102
export const MENUID_CURRENCYSETUP = 103111
export const MENUID_POSTINGSETUP = 103104
export const MENUID_PERIODSETUP = 103105
export const MENUID_ACCDEFINITION = 103106
export const MENUID_ACCFORMAT = 103107
export const MENUID_SEGMENTS = 103108
export const MENUID_EXCHANGE_RATE = 103103
export const MENUID_INCOALIST = 103401
export const MENUID_BATCHENTRY = 103201
export const MENUID_GLENTRY = 103202

// Human Resource
export const MENUID_HR_UNITS = 102102
export const MENUID_HR_DEPARTMENTS = 102103
export const MENUID_HR_EMPLOYEES = 102101

// Disbursement
export const MENUID_PAYMENT_NATURES = 104101
export const MENUID_PAYMENT_FORMS = 104102
export const MENUID_CASH_ACCOUNTS = 104103
export const MENUID_EOC_UNIT_APPROVAL_ROUTING = 104104
export const MENUID_EOC_ACCT_APPROVAL_ROUTING = 104105
export const MENUID_EOC_OFFICE_SITES = 104106
export const MENUID_EOC_UNBUDGETED_ACCOUNT = 104107
export const MENUID_EOC_CAODEPT_ACCESS = 104108
export const MENUID_EOC_ORIGINATOR_DEPARTMENT = 104109

export const MENUID_EOC_DISBURSEMENTS = 104201
export const MENUID_EOC_UNIT_APPROVAL = 104202
export const MENUID_EOC_ACCOUNTING_APPROVAL = 104203
export const MENUID_EOC_VENDOR_APPLICATION = 104204

export const MENUID_EOC_DISBURSEMENTS_INQUIRY = 104401
export const MENUID_EOC_APPROVAL_INQUIRY = 104402
export const MENUID_EOC_COMPLETED_PAYMENT_INQUIRY = 104403
export const MENUID_EOC_APPROVAL_LOGS_INQUIRY = 104404
export const MENUID_EOC_DETAILED_PAYMENTS_INQUIRY = 104405
export const MENUID_EOC_PAYEES_LOGS_INQUIRY = 104406
export const MENUID_EOC_NEW_PAYEES_INQUIRY = 104407
export const MENUID_EOC_WIRE_TRANSFER_INQUIRY = 104408
export const MENUID_EOC_COMPLETED_CONFIDENTIAL_INQUIRY = 104409
export const MENUID_EOC_ACCT_WIRE_TRANSFER_INQUIRY = 104410
export const MENUID_EOC_COMPLETED_IOT_INQUIRY = 104411
export const MENUID_EOC_FUNDS_TRANSFERS_INQUIRY = 104412
export const MENUID_EOC_TRANSMITTALS_INQUIRY = 104413

// Account Payable
export const MENUID_AP_VENDORS = 105101
export const MENUID_AP_SHIPPINGMM = 105102
export const MENUID_AP_TAXDETAILM = 105103

// Others to review
// export const MENUID_UNITS = 102102
// export const MENUID_CHARTSOFACCOUNTS = 102103
// export const MENUID_PRENTRY = 102201
// export const MENUID_PRAPROVAL = 102202

// ********************************************************
// API URL
// ********************************************************

// System
export const API_SYSTEM_ANNOUNCEMENTS = 'announcements'
export const API_CURRENCY = 'e001'
export const API_CURRENCYBASE = 'b001'

// General Ledger
export const API_CURRENCY_SETUP = 'c007'
export const API_ACCOUNT_FORMAT = 'c013'
export const API_ACCT_CATEGORY = 'c001'
export const API_ACCT_CHART = 'c008'
export const API_POSTING_SETTING = 'c006'
export const API_PERIOD_SETUP_DTO = 'c099'
export const API_ACCT_DEFINITION = 'c012'
export const API_BATCH_ENTRY = 'c101'
export const API_GL_ENTRY = 'c102'
export const API_EXCHANGE_RATE = 'c002'

// Human Resource
export const API_HR_UNITS = 'i001'
export const API_HR_DEPARTMENTS = 'p001'
export const API_HR_EMPLOYEES = 'emp'

// Disbursement
export const API_PAY_NATURE = 'y001'
export const API_PAY_FORM = 'y002'
export const API_CASH_ACCOUNT = 's001'
export const API_EOC_UNIT_APPROVAL_ROUTING = 'p002'
export const API_EOC_ACCT_APPROVAL_ROUTING = 'p003'
export const API_EOC_DISBURSEMENTS = 's002'
export const API_EOC_UNIT_APPROVAL = 'n002'
export const API_EOC_ACCOUNTING_APPROVAL = 'g001'
export const API_EOC_DISBURSEMENTS_INQUIRY = 'x088'
export const API_EOC_APPROVAL_INQUIRY = 'l002'
export const API_EOC_COMPLETED_PAYMENT_INQUIRY = 'm002'
export const API_EOC_OFFICE_SITES = 'o001'
export const API_EOC_VENDOR_APPLICATION = 'c001'
export const API_EOC_UNBUDGETED_ACCOUNT = 'y003'
export const API_EOC_CAODEPT_ACCESS = 'a003'
export const API_EOC_APPROVAL_LOGS_INQUIRY = 'o002'
export const API_EOC_DETAILED_PAYMENTS_INQUIRY = 'y004'
export const API_EOC_PAYEES_LOGS_INQUIRY = 'o003'
export const API_EOC_ORIGINATOR_DEPARTMENT = 'o004'
export const API_EOC_NEW_PAYEES_INQUIRY = 'n003'
export const API_EOC_WIRE_TRANSFER_INQUIRY = 'w001'
export const API_EOC_COMPLETED_CONFIDENTIAL_INQUIRY = 'm003'
export const API_EOC_ACCT_WIRE_TRANSFER_INQUIRY = 'w002'
export const API_EOC_COMPLETED_IOT_INQUIRY = 'i002'
export const API_EOC_FUNDS_TRANSFERS_INQUIRY = 't001'
export const API_EOC_TRANSMITTALS_INQUIRY = 't002'

// Account Payable
export const API_AP_VENDORS = 'ap001'
export const API_AP_SHIPPINGMM = 'ap002'
export const API_AP_TAXDETAILM = 'ap004'
